export function capterraTrackingListener() {
  const key = process.env.GATSBY_CAPTERRA_KEY;
  const capterraVid = '2137635';
  const ct = document.createElement('img');
  ct.src = `https://ct.capterra.com/capterra_tracker.gif?vid=${capterraVid}&vkey=${key}`;
  document.body.appendChild(ct);
}
